import script from "./OTPView.vue?vue&type=script&setup=true&lang=ts"
export * from "./OTPView.vue?vue&type=script&setup=true&lang=ts"

import "./OTPView.vue?vue&type=style&index=0&id=db2ebfcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db2ebfcc"]])

export default __exports__